import useGetApi from "api/hooks/useGetApi"
import useMutateApi from "api/hooks/useMutateApi"
// constants
import apiEndpoints from "api/utils/apiEndpoints"
import queryKeys from "api/utils/queryKeys"
import getUrl from "api/apiMap"

const useGetFavoriteRequests = (queryOptions) => {
  return useGetApi(getUrl(apiEndpoints.favoriteRequests), queryKeys.favoriteRequests, queryOptions)
}

// toggle request's favorite boolean value
const usePostFavoriteRequest = (requestId) => {
  return useMutateApi({
    method: "post",
    apiEndpoint: getUrl(`${apiEndpoints.requests}${requestId}/favorite/`),
    invalidateQueries: [queryKeys.requests.all, queryKeys.favoriteRequests],
    successMsg: "Successfully updated favorite request",
  })
}

export {
  useGetFavoriteRequests,
  usePostFavoriteRequest,
}